'use client';

import cn from 'classnames';
import { Text, Tooltip } from '@/shared/ui/core';
import { getHealth } from '../lib/get-health';
import { getWindowStats } from '../lib/get-window-stats';
import { useServiceStatusMonitor } from '../model/use-service-status-monitor';
import styles from './service-status.module.scss';


interface AuthStatusMonitorProps {
    intervalMs?: number;
    windowMs?: number;
    className?: string;
}


export function ServiceStatus ({ intervalMs = 60_000, windowMs = 5 * 60_000, className }: AuthStatusMonitorProps) {
    const { checks } = useServiceStatusMonitor(intervalMs);

    const now               = Date.now();
    const { total, passed } = getWindowStats(checks, windowMs, now);
    const latest            = checks.at(-1) ?? null;
    const { state, tone }   = getHealth(latest, passed, total);
    const windowMin         = Math.round(windowMs / 60_000);
    const title             = `${ state }\n${ passed } of ${ total } last status check${ passed > 1
        ? 's'
        : '' } passed in last ${ windowMin } minutes`;

    return (
        <Tooltip
            content={ title }
            side="bottom"
        >
            <div className={ cn(styles.root, className) }>
                <Text
                    as="span"
                    weight="medium"
                    className={ styles.dot }
                    tone={ tone }
                    lineHeight={ 1 }
                    data-health={ state }
                    role="status"
                    aria-label={ title }
                >
                    &bull;
                </Text>

                <Text
                    as="span"
                    weight="medium"
                    lineHeight={ 1 }
                    className={ styles.word }
                >
                    Status
                </Text>
            </div>
        </Tooltip>
    );
}
